import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';

/**
 * Utility to compare selected policy and current policy of a section in assign policy context submenu
 * @param retentionTag the newly clicked retention tag
 * @param retentionId the previous retention id of the selected policy
 * @param inheritSubMenuIdentifier identifier to know whether the item belongs to archive or delete section
 */
export default function isSelectedPolicyDifferentForItem(config: {
    retentionTag: RetentionTagType;
    retentionId: string;
    inheritSubMenuIdentifier: string;
}): boolean {
    const { retentionTag, retentionId, inheritSubMenuIdentifier } = config;
    const isTagDifferentByValue = !!retentionTag && retentionId != retentionTag.Value;
    const isTagNew = !retentionTag && retentionId != inheritSubMenuIdentifier;
    return isTagDifferentByValue || isTagNew;
}
